import { AddIcon } from 'assests/GmsIcons';
import React from 'react';

type TAddButtonProps = {
    onClick: () => void
}

const AddButton = ({onClick}: TAddButtonProps) => {
    return (
        <div aria-label="Add" role="button" data-testid="components-addbutton-div-1" onClick={onClick} className="tw-w-6 tw-h-6 tw-ms-2  tw-p-2.5 tw-cursor-pointer !tw-bg-[#747593] hover:!tw-bg-[#56587a] tw-rounded tw-justify-center tw-items-center tw-gap-2.5 tw-inline-flex">
            <button aria-label="Add" data-testid="components-addbutton-button-1" >
                <AddIcon color={'#fff'}/>             
            </button>
        </div>
    );
}

export default AddButton;
